const ITEMS = [
  "Waterfront Estates",
  "Private Docks",
  "Lagoon Living",
  "Exclusive Listings",
  "Market Insights",
  "September Issue Out Now",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="border-y border-[#E890A7]/10 bg-[#0D0B0E] py-5 overflow-hidden select-none">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display italic text-xl sm:text-2xl text-[#E890A7]/45 tracking-wide px-6">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#E890A7]/30" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
